export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "provide_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseigner mon IBAN"])},
        "confirm_iban": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Confirmer mon IBAN ", _interpolate(_named("iban"))])},
        "change_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier mon IBAN"])},
        "iban_confirmed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vos coordonnées bancaires sont confirmées"])}
      },
      "en": {
        "provide_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provide my IBAN"])},
        "confirm_iban": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Confirm my IBAN ", _interpolate(_named("iban"))])},
        "change_iban": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change my IBAN"])},
        "iban_confirmed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your bank details are confirmed"])}
      }
    }
  })
}
